var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2,
    height: 3,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54492 0.0986328C3.68497 0.0986328 0.544922 3.23868 0.544922 7.09863C0.544922 10.9586 3.68497 14.0986 7.54492 14.0986C11.4049 14.0986 14.5449 10.9586 14.5449 7.09863C14.5449 3.23868 11.4049 0.0986328 7.54492 0.0986328Z",
    fill: "#F79138"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.82953 4.60543C5.61475 4.39064 5.26651 4.39064 5.05172 4.60543C4.83693 4.82022 4.83693 5.16846 5.05172 5.38324L6.76285 7.09438L5.03351 8.7865C4.8164 8.99894 4.81261 9.34716 5.02505 9.56427C5.23749 9.78138 5.58571 9.78517 5.80282 9.57273L7.54072 7.87225L9.26008 9.59161C9.47487 9.8064 9.82311 9.8064 10.0379 9.59161C10.2527 9.37682 10.2527 9.02858 10.0379 8.81379L8.327 7.10289L10.0567 5.4104C10.2738 5.19796 10.2776 4.84974 10.0652 4.63263C9.85275 4.41552 9.50453 4.41173 9.28742 4.62417L7.54913 6.32503L5.82953 4.60543Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagClose);
export default __webpack_public_path__ + "static/media/tagClose.4555865d1c7bbfc488492f7f7a95b920.svg";
export { ForwardRef as ReactComponent };